import axios from 'axios';

import Util from '../util';

const apiUrl = process.env.REACT_APP_API_URL;

const FilterSetsAPI = {
  /**
   * Get filter sets for current organization
   * @param {object} cancelToken - Token axios
   * @returns {object} Filter sets of current organization
   */
  getFilterSets: async (cancelToken) => {
    const { data: { data } } = await Util.catch418And403Error(
      axios.get,
      `${apiUrl}/filtersets`,
      Util.apiGetCallSettings(cancelToken),
    );

    return data;
  },

  /**
   * Create a new filter set based on the given parameters
   * @param {object} postData - object of data
   * @param {object} cancelToken - Token axios
   * @returns {object} Newly created filter set
   */
  createFilterSet: async (postData, cancelToken) => {
    const { data } = await Util.catch418And403Error(
      axios.post,
      `${apiUrl}/filtersets`,
      postData,
      Util.apiPostCallSettings(cancelToken),
    );

    return data;
  },

  /**
   * Updates an existing filter set based on the given parameters
   * @param {string} id - Id of the filter set
   * @param {object} postData - object of data
   * @param {object} cancelToken - Token axios
   * @returns {object} Updated filter set
   */
  updateFilterSet: async (
    id,
    postData,
    cancelToken,
  ) => {
    const { data } = await Util.catch418And403Error(
      axios.put,
      `${apiUrl}/filtersets/${id}`,
      postData,
      Util.apiPostCallSettings(cancelToken),
    );

    return data;
  },

  /**
   * Delete filter set based the on a given id
   * @param {string} id - Id of the filter set that's going to be deleted
   * @param {object} cancelToken - Axios token
   * @returns {object} Deleted filter set
   */
  deleteFilterSet: async (
    id,
    cancelToken,
  ) => {
    const { data } = await Util.catch418And403Error(
      axios.delete,
      `${apiUrl}/filtersets/${id}`,
      Util.apiPostCallSettings(cancelToken),
    );

    return data;
  },
};

export default FilterSetsAPI;
